import React from 'react';
import './MainPage.css';

const MainPage: React.FC = () => {
  const hostname = window.location.hostname || 'Server';
  const chars = hostname.split('');

  return (
    <div className="main-page" role="main">
      <h1 className="main-hostname">
        {chars.map((char, idx) => (
          <span
            key={idx}
            className="char-block"
            style={{
              '--char-index': idx,
            } as React.CSSProperties & { '--char-index': number }}
          >
            {char}
          </span>
        ))}
      </h1>
    </div>
  );
};

export default MainPage;

